import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetID } from 'common/models/widget.model';
import {
  WizardStep,
  ExportPptModel,
  Exportable,
  ToggleExportablePayload,
} from '../../models/pptx.model';

// identifier
export const EXPORT_PPT_MODAL_SLICE_ID = 'exportPptModal';

// default state
const initialState: ExportPptModel = {
  visible: false,
  flyoutOpen: false,
  exportables: {},
  wizardStep: WizardStep.PowerpointExportChooseOption,
  exportTotal: 0,
  exportProgress: 0,
  showProgressBar: false,
  exportRunningInBackground: false,
};

//slice
const exportPptModalSlice = createSlice({
  name: EXPORT_PPT_MODAL_SLICE_ID,
  initialState,
  reducers: {
    setExportables: (
      state: ExportPptModel,
      action: PayloadAction<{ [key: WidgetID]: Exportable }>
    ): void => {
      Object.keys(action.payload).forEach(
        (exportable: string) => (state.exportables[exportable] = action.payload[exportable])
      );
    },
    clearExportables: (state: ExportPptModel): void => {
      state.exportables = {};
    },
    toggleExportable: (
      state: ExportPptModel,
      action: PayloadAction<ToggleExportablePayload>
    ): void => {
      state.exportables[action.payload.id].state = action.payload.state;
    },
    showPptFlyout: (state: ExportPptModel) => {
      state.flyoutOpen = true;
      state.wizardStep = WizardStep.PowerpointExportSummary;
    },
    showPaginatedPptFlyout: (state: ExportPptModel) => {
      state.flyoutOpen = true;
      state.wizardStep = WizardStep.PowerpointExportChooseOption;
    },
    hidePptFlyout: (state: ExportPptModel) => {
      state.flyoutOpen = false;
    },
    setWizardStep: (state: ExportPptModel, action: PayloadAction<WizardStep>) => {
      state.wizardStep = action.payload;
    },
    setExportProgress: (state: ExportPptModel, action: PayloadAction<number>) => {
      state.exportProgress = action.payload;
    },
    setExportTotal: (state: ExportPptModel, action: PayloadAction<number>) => {
      state.exportTotal = action.payload;
    },
    setShowExportProgressBar: (state: ExportPptModel, action: PayloadAction<boolean>) => {
      state.showProgressBar = action.payload;
    },
    setRunningInBackground: (state: ExportPptModel, action: PayloadAction<boolean>) => {
      state.exportRunningInBackground = action.payload;
    },
  },
});

//selectors

export const selectPptModalVisible = (state: RootState) => state.exportPptModal.visible;

export const selectPptExportables = (state: RootState) => state.exportPptModal.exportables;

export const selectIsPptFlyoutVisible = (state: RootState) => state.exportPptModal.flyoutOpen;

export const selectWizardStep = (state: RootState) => state.exportPptModal.wizardStep;

export const selectExportProgress = (state: RootState) => state.exportPptModal.exportProgress;
export const selectExportTotal = (state: RootState) => state.exportPptModal.exportTotal;
export const selectShowProgressBar = (state: RootState) => state.exportPptModal.showProgressBar;
export const selectIsExportRunningInBackground = (state: RootState) =>
  state.exportPptModal.exportRunningInBackground;

//actions
export const {
  setExportables,
  clearExportables,
  toggleExportable,
  showPptFlyout,
  showPaginatedPptFlyout,
  hidePptFlyout,
  setWizardStep,
  setExportProgress,
  setExportTotal,
  setShowExportProgressBar,
  setRunningInBackground,
} = exportPptModalSlice.actions;

//reducer
export default exportPptModalSlice;
